/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';

export default {

  async listSiteUsersByCampaignId(config: {params: { id: number }}) {
    return Api().get('site_user/list_by_campaign', config);
  },

  async getResults(config: {params: { id: number }}) {
    return Api().get('site_user/results', config);
  },

  async getSelections(config: {params: { id: number }}) {
    return Api().get('site_user/selections', config);
  },

  async getSubjects(config: {params: { id: number }}) {
    return Api().get('site_user/subjects', config);
  },

  getReportUrlBySiteUser(config: {params: { siteUserId: number }}) {
    return Api().get('site_user/get_report_filename', config);
  },
};
